/**
 * Internationalised Span - This is to be used whenever a label is to be international.
 */
import React, {Component} from 'react';
import { connect } from 'react-redux'
import {LXi18n} from 'lxi18n';
import localisations from "./localisations";
import ReactHtmlParser from 'react-html-parser';

class ISpan extends Component{
    render(){
        return <span style={this.props.style}>{ReactHtmlParser(this.props.localisedChildren)}</span>
    }
}
export default ISpan = connect((state, ownProps) => {
    let i18n = new LXi18n(state.i18n.currentLanguageKey, localisations);
    return {
        localisedChildren: i18n.localise(ownProps.localisationId, ownProps.defaultValue, ownProps.options, localisations)
    }
})(ISpan);



// WEBPACK FOOTER //
// ./src/i18n/ISpan.js